<template>
    <div class="pack-list-btn" :class="{'not-ready' : !packItemReady, 'has-warning' : hasWarning}" :id="'pknItem-'+index">
        <p class="item-info item-name"> {{ productInfo.name }} </p>
        <p class="item-info">  
            <span v-if="unitFactor" class="unit-factor">
                {{ kStrings.kGLOB_QUANTITY }}: {{ unitFactor }}
		        </span>
            <span v-if="itemLabel" class="label-list-btn"> {{ itemLabel }} </span> 
        </p>
        
        <SelectionWidgetDesktop
            v-show="itemSelectionData && (!noOptionsProduct || withChoice)"
            v-model="selectedProduct"
            :item-index="index"
            :item-selection-data="itemSelectionData"
            :out-of-stock-pack="outOfStock"
            :empty-selection-warning="hasWarning"
            @pack-item-ready="packItemReady = true"
            ref="selectionWidget"
        >
            <template v-slot:floatBtn>
                <button class="pkn-option-select" @click="$refs.selectionWidget.updateShowOptionsPopup('')"> {{ widgetButtonLabel }} </button>
            </template>
        </SelectionWidgetDesktop>
    </div>
</template>

<script>
import SelectionWidgetDesktop from '../../SelectionWidgetDesktop';
import {storePdp} from '@/store/product-page';
import {isEmpty} from 'lodash-es';

export default {
    storePdp,
    name: 'PackItem',
    components: {
        SelectionWidgetDesktop,
    },
    props: {
        componentOrder: {
            type: Array,
            default: [],
        },
        emptySelectionWarning: {
            type: Boolean,
            default: false,
        },
       
        fieldKeys: Object,
        /*noSelection: {
            type: Boolean,
            default: false,
        },*/
        index: {
            type: Number,
            default: 0
        },
        optionTypes: [Object, Array],
        packItemHasAllVariantsOverride: {
            type: Boolean,
            default: false
        },
        statusOverride: {
            type: String,
            default: 'TI'  
        },
        overrideReasonDetail: {
            type: String,
            default: ''  
        },
        outOfStock: {
            type: Boolean,
            default: false
        },
        productInfo: Object,
        productsList: {
            type: Array,
            default: [],
        },
    },
    data: function() {
        return {
            selectedProduct: null,
            packItemReady: false // make the user choose for dynamic options
        };
    },

    computed: {
        currency() {
            return storePdp.getters['pdpDesktop/addToCartDesktop/currency'];
        },
        hasWarning() { // CURSED COMPUTED!!!
            return this.itemWarning ? this.globalCartWarningEvent && this.itemWarning : false;
        },
        kStrings() {
            return storePdp.getters.kStrings;
        },
        noOptionsProduct() {
            if(this.withChoice) {
                return false;
            }
            
            return this.optionTypes.length < 1 || this.singleOption || this.productsList.length < 2;
        },
        packData() {
            return storePdp.getters['pdpDesktop/addToCartDesktop/packData'];
        },
        itemSelectionData() {
            if(!isEmpty(this.productsList) && this.fieldKeys) {
                return {
                    productsList: this.productsList.length > 1 ? this.filterOverrideOptions(this.productsList) : this.productsList,
                    optionTypes: this.optionTypes,
                    fieldKeys: this.fieldKeys,
                    componentOrder: this.componentOrder,
                    singleOption: this.singleOption,
                    withChoice: this.withChoice
                };
            }
            
            return null;
        },
        globalCartWarningEvent() {
            return storePdp.getters['pdpDesktop/addToCartDesktop/globalCartWarningEvent'];
        },
        singleOption() {
            return !this.componentOrder.length || this.componentOrder.length == 1;
        },
        withChoice() {
            return this.productsList.length > 1 && !(this.optionTypes.hasOwnProperty("optionId") && this.optionTypes.length <= 1);
        },
        selectedPackProducts() {
            return storePdp.getters['pdpDesktop/addToCartDesktop/selectedPackProducts'];
        },
        
        /*selectedProduct() { // CURSED VUE AND HIS WEIRD REACTIVITY
            if(!this.selectedPackProducts.length) {
                return null
            }
            return this.selectedPackProducts[this.index];
        },*/
        unitFactor() {
            if(!this.selectedProduct && !this.selectedPackProducts[this.index]) {
                return '';
            }

            return this.selectedProduct ? this.selectedProduct.unitFactor : this.selectedPackProducts[this.index].unitFactor;
        },
        itemLabel() {
            //if(!this.selectedProduct || !this.noOptionsProduct) {
            if(!this.selectedProduct && !this.selectedPackProducts[this.index]) {
                return '';
            }
            
            return this.selectedProduct ? this.buildItemLabel(this.selectedProduct) : this.buildItemLabel(this.selectedPackProducts[this.index]);
        },
        widgetButtonLabel() {
            if(!this.selectedProduct) {
                return '';
            }

            return this.buildWidgetButtonLabel(this.selectedProduct);
        },
        itemWarning() {
            return !this.selectedProduct || !this.packItemReady;
        },
        readyPackItems() {
            return storePdp.getters['pdpDesktop/addToCartDesktop/readyPackItems'];
        },
        /*packItemReady() { // bastard vue and computed store arrays...
            if(isEmpty(this.readyPackItems)) {
                return false
            }
            
            return this.readyPackItems[this.index];
        }*/
    },
    watch: {
        selectedProduct(value, oldVal) {
            if(value) {
                this.updatePackPrices();
            }
        },
        packItemReady: {
            immediate: true,
            handler(value, oldValue) {
                storePdp.dispatch('pdpDesktop/addToCartDesktop/updateReadyPackItems', {index: this.index, ready: value});
            },
        },
    },
    created() {},
    mounted() {
        /*if(this.outOfStock && !this.packItemHasAllVariantsOverride) {
            bus.$emit('pkn-item-has-no-variants-available');
        }
        
        if(this.packItemHasAllVariantsOverride) {
            bus.$emit('pkn-item-has-no-variants-available',true, this.statusOverride,this.overrideReasonDetail);
        }
        
        */
        this.$nextTick(() => {
            storePdp.dispatch('pdpDesktop/addToCartDesktop/updateSelectedPackProducts', {index: this.index, selectedProduct: this.productsList[0]});
            this.packItemReady = this.packData.packType == 'packStatic' || this.noOptionsProduct;
            //storePdp.dispatch('pdpDesktop/addToCartDesktop/updateReadyPackItems', {index: this.index, sku: isReady ? this.productsList[0].sku : null});
            this.updatePackPrices();
        });
    },
    methods: {
        filterOverrideOptions(list){
            return list.filter(product => !product.overrideStatus);
        },
        buildItemLabel(product) {
            let label, option = null;
            let extraLabel = null; // for sizes etc
            if (product.flavorDescription) {
                label = product.flavorLabelDescription;
                option = product.flavorDescription;
            } else if (product.colorDescription) {
                label = product.colorLabelDescription;
                option = product.colorDescription;
                if(product.sizeLabelDescription) {
                    extraLabel = product.sizeLabelDescription + ': ' + product.sizeDescription;
                }
            }

            if(!this.packItemReady) {
                option = this.kStrings.kCHOOSE;
            }
            
            let labelBuild = option ? label + ': ' + option : null;
            if (extraLabel) {
                if (labelBuild) {
                    labelBuild = labelBuild + '; ' + extraLabel;
                } else {
                    labelBuild = extraLabel;
                }
            }
            
            return labelBuild;
        },
        
        buildWidgetButtonLabel(product) {
            let label = '';
            if (product.flavorDescription) {
                label = product.flavorLabelDescription;
            } else if (product.colorDescription) {
                label = product.colorLabelDescription;
            } else if(product.sizeLabelDescription) {
                label = product.sizeLabelDescription;
            }
            
            return label ? this.kStrings.kCHOOSE_NO_ELLIPSIS + ' ' + label : label;
        },

        updatePackPrices() {
            let packPrice = '';
            let packPartnerPrice = '';
            let bestPriceCoupon = null;
            if(this.packData.packType === 'packStatic'){
                const packInfo = this.packData.basePackInfo;
                packPrice = packInfo.minPrice;
                packPartnerPrice = packInfo.pricePartner;
                bestPriceCoupon = packInfo.bestPriceCoupon;
            } else if(this.selectedPackProducts.length > 0) {
                const price = this.selectedPackProducts.reduce((packPrice, packProduct) => packPrice + packProduct.priceVal, 0);
                packPrice = App.js.formatPrice(price);
                if (this.selectedPackProducts[0].partnerPriceVal !== undefined) {
                    const partnerPrice = this.selectedPackProducts.reduce((packPrice, packProduct) => packPrice + packProduct.partnerPriceVal, 0);
                    packPartnerPrice = App.js.formatPrice(partnerPrice);
                }
            }
            if(packPrice) {
                storePdp.dispatch('updatePrice', {
                    price: packPrice,
                    priceReference: packPartnerPrice,
                    bestPriceCoupon: bestPriceCoupon,
                }); 
            }
        },
        // important -> set packitem ready to add to cart
        /*setPackItemReady() {
            this.packItemReady = true;
                //storePdp.commit('pdpDesktop/addToCartDesktop/setReadyPackItems', {index: index, sku: this.selectedProduct.sku});
        }*/
    },
};

</script>

<style lang="scss"></style>
